module.exports = __webpack_public_path__ + "img/Hooter-Owl-Den.ef1a8734.jpg";